import statesModule from './modules/states';
import tableModule from './modules/table';

const state = {
  ...statesModule.state,
  ...tableModule.state,
  serviceName: 'order_states',
  debt: null,
};

const getters = {
  ...statesModule.getters,
  ...tableModule.getters,
};

const actions = {
  ...statesModule.actions,
  ...tableModule.actions,

  async fetchOrderDebt(context, { orderId, dollarQuotation, receiptId }) {
    const { data } = await this.$services.resource('orders').getDebt(orderId, { dollarQuotation, receiptId });

    context.commit('SET_ORDER_DEBT', data);
  },
};

const mutations = {
  ...statesModule.mutations,
  ...tableModule.mutations,

  SET_ORDER_DEBT(state, debt) {
    state.debt = debt;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
